export const operators = {
    'CM': [
        { code: 'OM', name: 'Orange Money' },
        { code: 'MOMO', name: 'MTN Mobile Money' }
    ]
}; 